<template>
  <div>
    <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium" @keyup.enter.native.prevent="getList" label-suffix="：">
      <el-row>
        <el-form-item label="客户">
          <el-select filterable v-model="searchForm.TC_ID" placeholder="请选择客户" clearable @change="onTcChange">
            <el-option v-for="item in tcList" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点">
          <el-select filterable v-model="searchForm.PROJECT_ID" placeholder="请选择项目点" clearable>
            <el-option v-for="item in projectList" :key="item.PROJECT_ID" :label="item.PROJECT_NAME" :value="item.PROJECT_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期">
          <el-date-picker v-model="searchForm.SEND_DAY" type="date" value-format="yyyy-MM-dd" placeholder="请选择送货日期" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="司机">
          <el-select filterable v-model="searchForm.DRIVER_ID" placeholder="请选择司机" clearable>
            <el-option v-for="item in driverList" :key="item.RECORD_ID" :label="`${item.DRIVER}${item.CELLPHONE ? ` - ${item.CELLPHONE}` : ''}`"
              :value="item.RECORD_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单配送状态">
          <el-select filterable v-model="searchForm.DELIVERY_STATUS" placeholder="请选择订单配送状态" clearable>
            <el-option v-for="item in deliveryStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button type="primary" @click="search">筛选</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="ORDER_ID" label="订单ID"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户名称"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
          <el-table-column prop="DELIVERY_STATUS" label="配送订单状态">
            <template slot-scope="scope">
              {{ deliveryStatusList[scope.row.DELIVERY_STATUS].label }}
            </template>
          </el-table-column>
          <el-table-column prop="DRIVER" label="司机名称"></el-table-column>
          <el-table-column prop="LINE_NAME" label="线路"></el-table-column>
          <el-table-column prop="LICENSE_PLATE" label="车辆"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="showOrderDetail(scope.row)">订单详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-pagination @current-change="getTableData" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
        :total="totalCount" style="float: right;">
      </el-pagination>
    </el-row>
    <el-drawer title="订单详情" :visible.sync="orderDetailDrawer" size="80%">
      <el-descriptions :title="`订单ID：${orderDetailObj.info.ORDER_ID}`" :column="2" border>
        <el-descriptions-item label="供应商">{{ orderDetailObj.info.SUPPLIER_NAME }}</el-descriptions-item>
        <el-descriptions-item label="制单人">{{ orderDetailObj.info.managerName }}</el-descriptions-item>
        <el-descriptions-item label="项目点">{{ orderDetailObj.info.PROJECT_NAME }}</el-descriptions-item>
        <el-descriptions-item label="档口">{{ orderDetailObj.info.DK_NAME }}</el-descriptions-item>
        <el-descriptions-item label="项目点地址">{{ orderDetailObj.info.PROJECT_ADDRESS }}</el-descriptions-item>
        <el-descriptions-item label="项目点电话">{{ orderDetailObj.info.TELPHONE }}</el-descriptions-item>
        <el-descriptions-item label="送货日期">{{ orderDetailObj.info.SEND_DAY }}</el-descriptions-item>
        <el-descriptions-item label="订单编号">{{ orderDetailObj.info.ORDER_CODE }}</el-descriptions-item>
        <el-descriptions-item label="订购总金额">{{ orderDetailObj.info.TOTAL_SUPPLIER_FEE }}</el-descriptions-item>
        <el-descriptions-item label="实收总金额">{{ orderDetailObj.info.REAL_TOTAL_SUPPLIER_FEE }}</el-descriptions-item>
      </el-descriptions>

      <el-table :data="orderDetailObj.detail" border stripe style="width: 100%; margin-top: 20px;">
        <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
        <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
        <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
        <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
        <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
        <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价（元）"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
        <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
        <el-table-column prop="TOTAL_FEE" label="总价（元）"></el-table-column>
        <el-table-column prop="CATALOG_NAME" label="分类"></el-table-column>
        <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import { orderConfirmDetailFun, selectTCFun } from '@/assets/api/sellOrder';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      searchForm: {
        SEND_DAY: date(new Date(), '%F'),
      },
      tableData: [],
      tcList: [],
      projectList: [],
      driverList: [],
      deliveryStatusList: [{ value: 0, label: '待配送' }, { value: 1, label: '配送中' }, { value: 2, label: '已完成' }],
      currentPage: 1,
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10,
      totalCount: 0,
      orderDetailDrawer: false,
      orderDetailObj: {
        info: {},
        detail: [],
      },
    };
  },
  created() {
    if (this.DELIVERY_TASK_PROGRESS.CONDITION) {
      this.searchForm = this.DELIVERY_TASK_PROGRESS.CONDITION;
      this.currentPage = this.DELIVERY_TASK_PROGRESS.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getTableData();
    this.getTcList();
    this.getProjectList();
    this.getDriverList();
  },
  computed: {
    DELIVERY_TASK_PROGRESS() {
      return this.$store.state.DELIVERY_TASK_PROGRESS;
    },
  },
  methods: {
    getTcList() {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.tcList = this.$util.listRemoveDuplicates(result[0].company);
        } else {
          this.tcList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getProjectList() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 18,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.TC_ID) params.TC_ID = this.searchForm.TC_ID;
      http.post(params).then((result) => {
        this.projectList = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getDriverList() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 6,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.driverList = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    onTcChange() {
      this.searchForm.PROJECT_ID = '';
      this.getProjectList();
    },
    getTableData() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
        SEND_DAY: this.searchForm.SEND_DAY,
      };
      if (this.searchForm.TC_ID) params.TC_ID = this.searchForm.TC_ID;
      if (this.searchForm.PROJECT_ID) params.PROJECT_ID = this.searchForm.PROJECT_ID;
      if (this.searchForm.DRIVER_ID) params.DRIVER_ID = this.searchForm.DRIVER_ID;
      if (this.searchForm.DELIVERY_STATUS) params.DELIVERY_STATUS = this.searchForm.DELIVERY_STATUS;
      http.post(params).then((res) => {
        if (res[0]) {
          this.$store.dispatch('SET_DELIVERY_TASK_PROGRESS', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
          this.tableData = res[0].LIST || [];
          this.totalCount = res[0].TOTAL_COUNT || 0;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    search() {
      this.currentPage = 1;
      this.getTableData();
    },
    showOrderDetail({ ORDER_ID }) {
      const params = {
        ORDER_ID,
      };
      orderConfirmDetailFun(params).then((result) => {
        if (result && result[0]) {
          const info = {
            ...result[0].TITLE[0], ORDER_ID, managerName: sessionStorage.getItem('name'),
          };
          const detail = result[0].DETAIL;
          this.orderDetailObj = { info, detail };
          this.orderDetailDrawer = true;
        } else {
          this.$message.show({ text: '未找到订单信息', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.el-drawer__wrapper /deep/ .el-drawer__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(100vh - 140px);
}
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/deliveryTaskProgress.vue